export default __webpack_public_path__ + "static/media/witchwake.e6c992a5.mp3";